import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';
import { getTrainingCompletionLeaderboard } from '../api/leaderboard';

export interface IDataTrainingCompletionList {
  rank: number;
  learner_id: number;
  learner_email?: string;
  first_name: string;
  last_name: string;
  segment?: string;
  total_points: number;
  training_status: number;
  report_count?: number;
  average_response_time_minutes?: string;
}

export interface IGroupTrainingCompletionList {
  rank: number;
  group: string;
  average_points: number;
  has_group: boolean;
}

export interface IPagination {
  "total_items": number,
  "total_page": number,
  "offset": number,
  "limit": number,
  "has_more": boolean
}

export interface IDataTrainingCompletion {
  rankings: {
    data:IDataTrainingCompletionList[],
    pagination:IPagination
  };
  groups: {
    data: IGroupTrainingCompletionList[],
    pagination:IPagination
  };
}

export interface GetAssignedLearningListObjectState {
  dataTrainingCompletion: IDataTrainingCompletion
  isLoading: boolean;
  error?: string;
}

const initialState: GetAssignedLearningListObjectState = {
  dataTrainingCompletion: {
    rankings: {
      data:[],
      pagination:{
        total_items: 0,
        total_page: 0,
        offset: 1,
        limit: 1,
        has_more: false
      }
    },
    groups: {
      data:[],
      pagination:{
        total_items: 0,
        total_page: 0,
        offset: 1,
        limit: 1,
        has_more: false
      }
    },
  },
  isLoading: false,
  error: undefined
};

export const getTrainingCompletionListEvents = createAsyncThunk(
  'getTrainingCompletionListEventLeaderboard',
  async (params: any) => {
    const response = await getTrainingCompletionLeaderboard(params);
    return response ? response : initialState;
  }
);

export const getTrainingCompletionListSlice = createSlice({
  name: 'getTrainingCompletionListEvents',
  initialState,
  reducers: {
    removeTrainingCompletion: (state) => {
      state.isLoading = false;
      state.dataTrainingCompletion = initialState.dataTrainingCompletion;
      state.error = undefined;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getTrainingCompletionListEvents.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(
      getTrainingCompletionListEvents.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.dataTrainingCompletion = action.payload;
        state.error = undefined;
      }
    );

    builder.addCase(getTrainingCompletionListEvents.rejected, (state, action) => {
      state.isLoading = false;
      state.dataTrainingCompletion = initialState.dataTrainingCompletion;
      state.error = action.payload as string;
    });
  }
});

export const { removeTrainingCompletion  } = getTrainingCompletionListSlice.actions;

export const getTrainingCompletionListEventsDataSelector = (state: RootState) =>
  state.getTrainingCompletionListEvents;
export default getTrainingCompletionListSlice.reducer;
